import React from 'react'
import './footer.css'
import nftlogo from '../../assets/logo.png'
import qrcode from '../../assets/parlock.kk_kreative_edition_qr.png'
import parlock from '../../assets/parlock.png'
import rarible from '../../assets/rarible.png'
import opensea  from '../../assets/Logomark-White.png'
import NFTcalender from '../../assets/nftcalendar.png'
import { AiOutlineInstagram,AiOutlineTwitter, } from "react-icons/ai";
import { RiDiscordFill } from "react-icons/ri";
import { FaTelegramPlane } from "react-icons/fa";
const Footer = () => {
  return (
    <div className='footer section__padding'>
      <div className="footer-links">
        <div className="footer-links_logo">
        <div>
          <img src={nftlogo} alt="logo" style={{ borderRadius: 100}}/>
          <p>ParLock</p>
        </div>
        <div>
        <p>As Seen On:</p>
        </div>
        <div>
          
          <a href='https://nftcalendar.io/'>
          <img src={NFTcalender} alt="logo" style={{ height:100, width:100}} height={100} width={100}/>
          </a>
        </div>
        <div>
          <input type="text" placeholder='Your Email' />
          <button>Email Me!</button>
        </div>
        </div>
        <div className="footer-links_div" style={{background:'white', borderRadius: 15, overflow:'hidden', padding: 20}}>
        <img src={parlock} alt="logo" style={{ borderRadius: 10}} />
        <p style={{alignSelf:'center', color:'black'}}>Twitter</p>
        </div>
        <div className="footer-links_div">
        <img src={qrcode} alt="logo" />
        </div>
      </div>
      <div style={{color:'white', fontSize:20}}>
        <a href='./AboutUs' style={{margin: '5px', textDecoration: 'underline'}}>About Us</a>
        <a href='./PricacyPolicy' style={{margin: '5px', textDecoration: 'underline'}}>Privacy Policy</a>
        <a href='./TermsCondition' style={{margin: '5px', textDecoration: 'underline'}}>Terms Condition</a>
      </div>
      <div className="footer-copyright">
        <div>
        <p> © {(new Date().getFullYear())} ParLock, Inc. All Rights Reserved</p>
        </div>
        <div>
        <a href="https://rarible.com/ParLock" style={{position:'absolute', right:'-0.5%', marginBottom: -6}}> 
        <img src={rarible} alt="logo" style={{height: '8.5%', width: '8.5%', borderRadius: 100, borderColor:'#ffff', borderWidth: 1}} className='footer-icon'/>
        </a>
        <a href="https://opensea.io/Parlock" style={{position:'absolute', right:'-1%', marginBottom: 2}}> 
        <img src={opensea} alt="logo" style={{height: '6.5%', width: '6.5%', borderRadius: 100, borderColor:'#ffff', borderWidth: 1}} className='footer-icon'/>
        </a>

        
        
        <a href="https://www.instagram.com/parlock.kk_kreative_edition/"> 
          <AiOutlineInstagram size={25} color='white' className='footer-icon' />
          </a>
          <a href="https://twitter.com/Kkk90513327"> 
          <AiOutlineTwitter size={25} color='white' className='footer-icon'/>
          </a>
          {/* <RiDiscordFill size={25} color='white' className='footer-icon'/>
          <FaTelegramPlane size={25} color='white'  className='footer-icon' /> */}
        </div>

      </div>
    </div>
  )
}

export default Footer
